import type { RouteObject } from 'react-router';
import { RequirePermission } from '@/app/require-permission';
import { AgendaPage } from './agenda-page';

export const appRoutes: RouteObject[] = [
  {
    path: 'agenda',
    element: (
      <RequirePermission anyOf={['agenda.read', 'agenda.read_all']}>
        <AgendaPage />
      </RequirePermission>
    ),
  },
];
